import React from 'react';
import '../index.css';
import './Home.css';

const Landing = (props) => {

  return (
  <div className="landing-container">
      <h1>Introducing ToneSense</h1>
      <h4>Effective writing powered by Machine Learning</h4>
      <small><p className="landing-slogan">Don't let a poorly worded email leave a bad taste — take control of your tone for successful writing.</p></small>
    </div>
  )
}

export default Landing; 